import EmblaCarousel from "embla-carousel"
import { addPrevNextBtnsClickHandlers } from "./embla/arrows"
import { addDotBtnsAndClickHandlers } from "./embla/dots"

export default class FeaturedRaces {
  constructor() {
    this.emblaNode = document.querySelectorAll(".featured-races .embla")

    if (!this.emblaNode.length) return

    this.emblaNode.forEach((node) => this.initCarousel(node))
  }

  initCarousel(node) {
    const viewportNode = node.querySelector(".embla__viewport")

    const leftEdge = node.querySelector(".embla__edge--start")
    const rightEdge = node.querySelector(".embla__edge--end")

    const prevBtnNode = node.querySelector(".embla__button--prev")
    const nextBtnNode = node.querySelector(".embla__button--next")
    const dotsNode = node.querySelector(".embla__dots")

    if (node && viewportNode) {
      const emblaApi = EmblaCarousel(viewportNode, {
        align: "start",
        dragThreshold: 5,
      })

      emblaApi.on("init", () => {
        this.toggleEdges(leftEdge, rightEdge, emblaApi)
      })

      emblaApi.on("resize", () => {
        this.toggleEdges(leftEdge, rightEdge, emblaApi)
      })

      emblaApi.on("scroll", () => {
        this.toggleEdges(leftEdge, rightEdge, emblaApi)
      })

      const removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(
        emblaApi,
        prevBtnNode,
        nextBtnNode,
      )
      const removeDotBtnsAndClickHandlers = addDotBtnsAndClickHandlers(emblaApi, dotsNode)

      emblaApi.on("destroy", removeDotBtnsAndClickHandlers)
      emblaApi.on("destroy", removePrevNextBtnsClickHandlers)
    }
  }

  toggleEdges(start, end, emblaApi) {
    const progress = Math.round(emblaApi.scrollProgress() * 100)

    if (progress <= 0) {
      start.classList.remove("is-visible")
    } else {
      start.classList.add("is-visible")
    }

    if (progress === 100) {
      end.classList.remove("is-visible")
    } else {
      end.classList.add("is-visible")
    }
  }
}
